import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import LoadingPage from '../../../../components/LoadingPage';
import {
  GeneratorForm,
  InvitePreview,
  PublishChecklist,
  SnippetOutput,
} from './components';
import { useGeneratorEnabled, useGeneratorForm } from './hooks';
import * as S from './styles';

const Generator = () => {
  const [t] = useTranslation('personalized-invite');
  const { enabled, loading } = useGeneratorEnabled();
  const {
    values,
    errors,
    snippet,
    logoUrl,
    bannerUrl,
    handleFieldChange,
    handleGenerate,
  } = useGeneratorForm();

  if (loading) return <LoadingPage />;
  if (!enabled) return <Redirect to="/" />;

  return (
    <S.Page>
      <S.Header>
        <S.Title>{t('generator.title')}</S.Title>
        <S.Subtitle>{t('generator.subtitle')}</S.Subtitle>
      </S.Header>
      <S.Content>
        <GeneratorForm
          values={values}
          errors={errors}
          onFieldChange={handleFieldChange}
          onGenerate={handleGenerate}
        />
        <InvitePreview
          values={values}
          logoUrl={logoUrl}
          bannerUrl={bannerUrl}
        />
      </S.Content>
      {snippet && (
        <S.Output>
          <SnippetOutput
            snippet={snippet}
            logoUrl={logoUrl}
            bannerUrl={bannerUrl}
          />
          <PublishChecklist
            personContextId={values.personContextId.trim()}
            logoFileName={snippet.logoFileName}
            bannerFileName={snippet.bannerFileName}
          />
        </S.Output>
      )}
    </S.Page>
  );
};

export default Generator;
